import { render } from "./GoogleMap.vue?vue&type=template&id=52456610"
import script from "./GoogleMap.vue?vue&type=script&lang=js"
export * from "./GoogleMap.vue?vue&type=script&lang=js"

import exportComponent from "/home/foderboxen/admin.foderboxen.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__